const publicKey = "27b5694f19884862b8a57bee6e8d4627"
export default publicKey